import { useFlags } from 'launchdarkly-react-client-sdk';
import React from 'react';

import { FEATURE_FLAGS_ENUM } from '@/constants/config';
import { useAppSelector } from '@/store/hooks';

export interface CustomColumnConfig {
  useCustomColumnDisplayName: boolean;
  customColumnDisplayNames: [
    string | undefined,
    string | undefined,
    string | undefined,
    string | undefined
  ];
}

const useCustomColumnConfig = (): CustomColumnConfig => {
  const flags = useFlags();
  const modifyColumnHeadersEnabled = flags[FEATURE_FLAGS_ENUM.LV14088ModifyColumnHeaders];
  const parameters = useAppSelector((state) => state.auth.userPassport?.user?.parameters);
  return React.useMemo(
    () => ({
      customColumnDisplayNames: [
        parameters?.CustomColumnDisplayName1 as string | undefined,
        parameters?.CustomColumnDisplayName2 as string | undefined,
        parameters?.CustomColumnDisplayName3 as string | undefined,
        parameters?.CustomColumnDisplayName4 as string | undefined,
      ],
      useCustomColumnDisplayName: !!modifyColumnHeadersEnabled && !!parameters?.UseCustomColumnDisplayName,
    }),
    [modifyColumnHeadersEnabled, parameters],
  );
};

export default useCustomColumnConfig;
